// @flow
/* eslint-disable no-underscore-dangle */
import { type Component } from 'react';

export type LiftedProps<State> = {
  state: State,
  onLiftedChange: (nextState: State) => void,
};

export type LiftedComponentProps<Props, State> = Props & LiftedProps<State>;

export type LiftedComponentClass<Props, State> = Class<
  Component<LiftedComponentProps<Props, State>, any>
> & {
  initialState: State,
};

export const lifted = <Props: any, State: {}>(
  WrappedComponent: Class<Component<Props, State>>
): LiftedComponentClass<Props, State> =>
  class LiftedComponent extends WrappedComponent {
    static initialState: State;
    state: State;
    props: LiftedComponentProps<Props, State>;

    static displayName = `Lifted${WrappedComponent.displayName || WrappedComponent.name || ''}`;

    initialized = false;

    get state() {
      return (this.props && this.props.state) || LiftedComponent.initialState;
    }

    set state(value: State) {
      if (!this.initialized && value) {
        this.initialized = true;
        LiftedComponent.initialState = value;
        this.props.onLiftedChange(value);
      }
    }

    componentDidMount() {
      if (super.componentDidMount) super.componentDidMount();
      if (this.props.state) {
        this.props.onLiftedChange(this.props.state);
      }
    }

    setState(reducer, callback) {
      if (typeof reducer === 'function' && this.props.onLiftedChange) {
        this.props.onLiftedChange(reducer(this.state, this.props));
      } else if (this.props.onLiftedChange) {
        this.props.onLiftedChange(reducer);
      }
      if (callback) callback();
    }
  };



// WEBPACK FOOTER //
// ../react-lib/src/lib/lifted-components/core/index.js